import { Box, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  padding: 0 24px;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 160px);

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'padding: 0 120px' : 'padding: 0 40px')};
  }
`

export const StyledInputCurrencyWrapper = styled(Box)`
  width: 100%;
  max-width: 520px;

  border-radius: 20px;

  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  
  .pancake-card-body {
    padding: 32px;
    background: transparent;
  }

  .pancake-card-header {
    background: transparent;
    border-bottom: 1px solid ${({ theme }) => theme.colors.cardBorder};
    padding: 24px 32px;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 32px);
    margin: 0 16px;
    border-radius: 16px;
    
    .pancake-card-body {
      padding: 24px;
    }
    
    .pancake-card-header {
      padding: 20px 24px;
    }
  }
`
